import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';

const Model = ({ show, onClose, onSubmit,title  }) => {
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');

  const handleSubmit = () => {
    onSubmit({ year, month });
  };
   useEffect(() => {
    if (show) {
      const now = new Date();
      const currentMonth = now.toLocaleString('default', { month: 'long' }); // e.g., "July"
      const currentYear = now.getFullYear().toString(); // e.g., "2025"
      setMonth(currentMonth);
      setYear(currentYear);
    }
  }, [show]);
    if (!show) return null;

return (
    <>
 
      <div
      className="modal show d-block d-flex justify-content-center align-items-center"
      style={{
        background: 'rgba(0, 0, 0, 0.5)',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1050,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className="modal-dialog" style={{ maxWidth: '360px', width: '100%' }}>
        <div className="modal-content p-4 rounded-4 shadow" style={{ border: 'none' }}>
          <h5 className="text-center fw-semibold mb-1">{title}</h5>
          <p className="text-center text-muted mb-4">Please select month</p>

          <div className="d-flex gap-2 mb-4">
            <select
              className="form-select rounded-3"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            >
              <option value="">Month</option>
              {[
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
              ].map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>

            <select
              className="form-select rounded-3"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">Year</option>
              {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>

          <div className="d-flex justify-content-between px-2">
            <button
              className="btn btn-link text-muted"
              onClick={onClose}
              style={{ textDecoration: 'none' }}
            >
              Cancel
            </button>

            <button
              className="btn px-4 rounded-4"
              style={{ backgroundColor: '#00AFFF', borderColor: '#00AFFF',color:'#FFFFFF' }}
              onClick={handleSubmit}
              disabled={!month || !year}
            >
              Download Report
            </button>
          </div>
        </div>
      </div>
    </div>
  
    </>
  );
};

export default Model;
